/**
 * DroidSelector操作类型
 * 定义所有可用的selector链式调用方法
 */
export enum SelectorOperation {
    // ==================== 文本匹配 ====================
    TEXT = 'text',
    TEXT_CONTAINS = 'textContains',
    TEXT_STARTS_WITH = 'textStartsWith',
    TEXT_ENDS_WITH = 'textEndsWith',
    TEXT_MATCHES = 'textMatches',

    // ==================== ID匹配 ====================
    ID = 'id',
    ID_CONTAINS = 'idContains',
    ID_STARTS_WITH = 'idStartsWith',
    ID_ENDS_WITH = 'idEndsWith',
    ID_MATCHES = 'idMatches',

    // ==================== 类名匹配 ====================
    CLASS_NAME = 'className',
    CLASS_NAME_CONTAINS = 'classNameContains',
    CLASS_NAME_STARTS_WITH = 'classNameStartsWith',
    CLASS_NAME_ENDS_WITH = 'classNameEndsWith',
    CLASS_NAME_MATCHES = 'classNameMatches',

    // ==================== 描述匹配 ====================
    DESC = 'desc',
    DESC_CONTAINS = 'descContains',
    DESC_STARTS_WITH = 'descStartsWith',
    DESC_ENDS_WITH = 'descEndsWith',
    DESC_MATCHES = 'descMatches',

    // ==================== 包名匹配 ====================
    PACKAGE_NAME = 'packageName',
    PACKAGE_NAME_CONTAINS = 'packageNameContains',
    PACKAGE_NAME_STARTS_WITH = 'packageNameStartsWith',
    PACKAGE_NAME_ENDS_WITH = 'packageNameEndsWith',
    PACKAGE_NAME_MATCHES = 'packageNameMatches',

    // ==================== 布尔属性 ====================
    CLICKABLE = 'clickable',
    LONG_CLICKABLE = 'longClickable',
    SCROLLABLE = 'scrollable',
    ENABLED = 'enabled',
    CHECKABLE = 'checkable',
    CHECKED = 'checked',
    FOCUSABLE = 'focusable',
    FOCUSED = 'focused',
    VISIBLE_TO_USER = 'visibleToUser',
    SELECTED = 'selected',
    PASSWORD = 'password',

    // ==================== 整数属性 ====================
    DEPTH = 'depth',
    INDEX_IN_PARENT = 'indexInParent',
    CHILD_COUNT = 'childCount',

    // ==================== 边界 ====================
    BOUNDS = 'bounds',
    BOUNDS_INSIDE = 'boundsInside',
    BOUNDS_CONTAINS = 'boundsContains',

    // ==================== 算法 ====================
    ALGORITHM = 'algorithm'
}

/**
 * 单个selector操作
 */
export interface SelectorOperationItem {
    /** 操作方法名 */
    method: SelectorOperation
    /** 参数值 */
    value: any
}

/**
 * Selector链式操作配置
 */
export interface NodeSelectorChain {
    /** 操作列表 */
    operations: SelectorOperationItem[]
}
